import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, connect } from 'react-redux'
import { ThemeContext } from 'styled-components'

import { Row, Col, ContainerFluid } from '@navent-jobs/ui-kit/components/grid'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

import {
  ModalComponent,
  FooterContent,
  CustomButton,
  Container,
  ModalFooterComponent,
  TitleContainer,
  IconContainer,
} from './mixins'
import Motivos from './components/motivos'
import Detalle from './components/detalle'
import Exito from './components/exito'
import { denunciarAviso, getMotivosDenuncia } from '../../../../../../redux/actions/denuncia'
import { DenunciaAviso } from '../../../../../../redux/types/denuncia'
import { showSnackbarError } from '../../../../../../redux/actions/applicant/curriculum/snackbar'

interface ModalDenunciaProps {
  idAviso: number
  width: number
  visible: boolean
  closeModal: Function
  motivos: any
  denunciaStates: any
  motivosStates: any
}

interface ModalFooterProps {
  footer: Element
}

const MOTIVO_ID_DUPLICADO = 5

const ModalFooter = ({ footer }: ModalFooterProps) => {
  return (
    <ModalFooterComponent>
      <ContainerFluid>
        <Row>
          <Col>
            <FooterContent>{footer}</FooterContent>
          </Col>
        </Row>
      </ContainerFluid>
    </ModalFooterComponent>
  )
}

const ModalDenuncia = ({
  idAviso,
  width,
  visible,
  closeModal,
  motivos,
  motivosStates,
  denunciaStates,
}: ModalDenunciaProps) => {
  const { t }: { t: any } = useTranslation()
  const dispatch = useDispatch()
  const [paso, setPaso] = useState<number | undefined>(undefined)
  const [motivoSeleccionado, setMotivoSeleccionado] = useState<number | undefined>(undefined)
  const [subOptionSelected, setSubOptionSelected] = useState(0)
  const [textareaValue, setTextareaValue] = useState('')
  const { colors } = useContext<{ colors }>(ThemeContext)

  const resetValues = () => {
    setPaso(undefined)
    setMotivoSeleccionado(undefined)
    setSubOptionSelected(0)
    setTextareaValue('')
  }

  const onClose = () => {
    if (closeModal) {
      closeModal()
      resetValues()
    }
  }

  const denunciar = () => {
    if (motivoSeleccionado) {
      const denuncia: DenunciaAviso = {
        idAviso: +idAviso,
        idMotivo: motivoSeleccionado,
      }
      if (subOptionSelected !== 0) {
        denuncia.idSubmotivo = +subOptionSelected
      }
      if (textareaValue) {
        denuncia.descripcion = textareaValue
      }
      dispatch(denunciarAviso(denuncia))
    }
  }

  const PASOS = {
    1: {
      // eslint-disable-next-line react/display-name
      buttons: (
        <CustomButton buttonoptions={{ variant: 'primary', size: 'medium', block: true }} onClick={onClose}>
          Cancelar
        </CustomButton>
      ),
      title: t('modalDenuncia.title'),
      component: (
        <Motivos
          isLoading={motivosStates.loading}
          data={motivos}
          onClickOption={e => {
            setMotivoSeleccionado(e)
            setPaso(2)
          }}
        />
      ),
    },
    2: {
      // eslint-disable-next-line react/display-name
      buttons: (
        <>
          <CustomButton
            onClick={() => {
              setPaso(1)
              resetValues()
            }}
            buttonoptions={{ variant: 'primary', size: 'medium', type: 'link', block: true }}
          >
            Volver
          </CustomButton>
          <CustomButton
            buttonoptions={{ variant: 'primary', size: 'medium', block: true }}
            onClick={denunciar}
            isLoading={denunciaStates.loading}
            disabled={
              !(motivoSeleccionado && textareaValue !== '' && subOptionSelected !== 0) &&
              motivoSeleccionado !== MOTIVO_ID_DUPLICADO &&
              !(motivoSeleccionado === 6 && textareaValue !== '')
            }
          >
            Denunciar
          </CustomButton>
        </>
      ),
      // eslint-disable-next-line react/display-name
      title: (
        <TitleContainer>
          <IconContainer
            onClick={() => {
              resetValues()
              setPaso(1)
            }}
          >
            <Icon name="icon-light-arrow-left" color={colors.secondary.normal} size="24" />
          </IconContainer>
          {t('modalDenuncia.titleMotivo')}
        </TitleContainer>
      ),
      component: (
        <Detalle
          motivos={motivos}
          motivoSeleccionado={motivoSeleccionado}
          setSubOptionSelected={setSubOptionSelected}
          subOptionSelected={subOptionSelected}
          textareaValue={textareaValue}
          setTextareaValue={setTextareaValue}
        />
      ),
    },
    3: {
      // eslint-disable-next-line react/display-name
      buttons: (
        <CustomButton buttonoptions={{ variant: 'primary', size: 'medium', block: true }} onClick={onClose}>
          Listo
        </CustomButton>
      ),
      title: '',
      component: <Exito />,
    },
  }

  useEffect(() => {
    if (visible && !motivos && !motivosStates.loading) {
      dispatch(getMotivosDenuncia())
    }
  }, [visible])

  useEffect(() => {
    if (denunciaStates.success) {
      setPaso(3)
    }
    if (denunciaStates.error) {
      dispatch(showSnackbarError('Ha ocurrido un error.'))
    }
  }, [denunciaStates])

  return (
    <ModalComponent
      width={width}
      visible={visible}
      onClose={onClose}
      title={PASOS[paso || 1].title}
      footer={<ModalFooter footer={PASOS[paso || 1].buttons} />}
    >
      <ContainerFluid>
        <Container>{PASOS[paso || 1].component}</Container>
      </ContainerFluid>
    </ModalComponent>
  )
}

const states = ({ denunciaStore }) => ({
  motivos: denunciaStore.motivos,
  motivosStates: denunciaStore.motivosStates,
  denunciaStates: denunciaStore.denunciaAvisoStates,
})

export default connect(states)(ModalDenuncia)
